import styled from 'styled-components';
import { mb, ml } from '@lendi-ui/spacing';
import { Article, FigureLink } from '../ArticleCard/index.style';

export const ArticleScrollWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
`;

export const ArticleScroller = styled.div`
  display: inline-flex;
  min-width: 100%;

  ${Article} {
    width: 50%;
    min-width: 16rem;
    border: none;
    ${mb('xs')}
    ${ml('sm')}
    &:first-child {
      ${ml('nil')}
    }

    ${FigureLink} {
      height: 30vw;
      min-height: 9rem;
      max-height: 21rem;
    }
  }
`;
